/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_TeamInputs */



/**
* | output |
* | --- |
* | "Team Projects & Collaboration" |
*
* @param {Signup_Compare_TeamInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_team = /** @type {((inputs?: Signup_Compare_TeamInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_TeamInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	if (locale === "de") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	if (locale === "it") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	if (locale === "es") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
	return /** @type {LocalizedString} */ ("Team Projects & Collaboration")
});